module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead5-b7946b4776cdcd8baa0dc9742a0bd89c.jpg";